import { render } from "./AtencionesPorPaciente.vue?vue&type=template&id=3b1174ae&scoped=true"
import script from "./AtencionesPorPaciente.vue?vue&type=script&lang=js"
export * from "./AtencionesPorPaciente.vue?vue&type=script&lang=js"

import "./AtencionesPorPaciente.vue?vue&type=style&index=0&id=3b1174ae&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1174ae"]])

export default __exports__